import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.checkliste-identifier';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenChecklisteIdentifierEffects {

    ChecklisteIdentifier$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_CHECKLISTE_IDENTIFIER),
        mergeMap((x: ac.GetChecklisteIdentifierAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getChecklisteIdentifier().pipe(
                map((result: any) => {
                    return new ac.GetChecklisteIdentifierErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetChecklisteIdentifierFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VorlagenTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VorlagenTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.VorlagenTemplatesService);
        }
        return this.service;
    }
}
